import { Link } from "react-router-dom";
import { Phone, MapPin, CreditCard, MessageSquare } from "lucide-react";
import { COMPANY, NAV_LINKS, SERVICES } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#2E1605] text-[#FAFAFA] mt-auto">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <img src={COMPANY.logo} alt={COMPANY.name} className="h-12 w-12 object-contain bg-white/95 rounded-sm p-1" />
              <span className="font-heading font-black text-xl tracking-tight">BETA-TECH</span>
            </div>
            <p className="text-sm leading-relaxed text-[#D9CFC8] max-w-xs">
              Trusted IT service and support for businesses in and around Baton Rouge, Louisiana.
            </p>
            <a
              href={COMPANY.paymentUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-payment-btn"
              className="mt-6 inline-flex items-center gap-2 bg-[#FFA500] text-[#1A110B] font-heading font-black tracking-wider uppercase text-xs px-5 py-2.5 rounded-sm hover:-translate-y-0.5 transition-transform"
            >
              <CreditCard className="h-4 w-4" /> Make a Payment
            </a>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-[#00B4C4] mb-5">Services</h4>
            <ul className="space-y-3 text-sm text-[#D9CFC8]">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link data-testid={`footer-service-${s.slug}`} to="/services" className="hover:text-white transition-colors">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-[#00B4C4] mb-5">Company</h4>
            <ul className="space-y-3 text-sm text-[#D9CFC8]">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link data-testid={`footer-nav-${l.label.toLowerCase()}`} to={l.to} className="hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
              <li><Link data-testid="footer-nav-terms" to="/terms" className="hover:text-white transition-colors">Terms</Link></li>
              <li><Link data-testid="footer-nav-privacy" to="/privacy" className="hover:text-white transition-colors">Privacy</Link></li>
              <li><Link data-testid="footer-nav-sms-terms" to="/sms-terms" className="hover:text-white transition-colors">SMS Terms</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-[#00B4C4] mb-5">Get in touch</h4>
            <ul className="space-y-4 text-sm text-[#D9CFC8]">
              <li className="flex items-start gap-3"><Phone className="h-4 w-4 mt-0.5 text-[#00B4C4]" /><a href={`tel:${COMPANY.phone}`} className="hover:text-white">{COMPANY.phone}</a></li>
              <li className="flex items-start gap-3"><MessageSquare className="h-4 w-4 mt-0.5 text-[#00B4C4]" /><Link data-testid="footer-contact-link" to="/contact" className="hover:text-white">Send us a message</Link></li>
              <li className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-0.5 text-[#00B4C4]" />{COMPANY.address}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#B8ABA2]">
          <p>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</p>
          <p>{COMPANY.domain}</p>
        </div>
      </div>
    </footer>
  );
}
